module.exports = __webpack_public_path__ + "media/images/cosmos-6b0dc70c2268fee7e9fcae67d842758a.svg";